/* eslint-disable max-len */
import DispatchersMixin from '@/mixins/dispatchers';

export default {
  name: 'ExpandTable',
  mixins: [DispatchersMixin],

  /**
   * @override
   */
  data() {
    return {
      distributors: {},
      sibdistributors: {},
      modalId: 'modal-add',
      deleteModalId: 'modal-delete',
      editModalId: 'modal-edit',
      distributorSelected: {},
      form: {},
      deleteEntity: {},
      type: 'distributor'
    };
  },
  methods: {
    /**
     * @override
     */
    fetchData() {
      const cfg = {};
      cfg.params = {};
      if (this.limit) {
        cfg.params.$limit = this.limit;
      }
      const metodo = this.$distributorsService.getDistributors;
      metodo('', cfg).then(res => {
        this.distributors.items = res.data.distributors;
        this.distributors.items.forEach(dist => {
          dist.showDetails = false;
          dist.key = dist.key_name;
        });
      });
    },
    /**
     * @override
     */
    expandDist(idx) {
      this.distributors.items[idx].showDetails = !this.distributors.items[idx].showDetails;
      const dist = this.distributors.items[idx];
      this.distributors.items.splice(idx, 1);
      this.distributors.items.splice(idx, 0, dist);
    },
    /**
     * @override
     */
    showModal(type, distributor) {
      this.type = type;
      if (distributor) {
        this.distributorSelected = distributor;
      }
      this.$bvModal.show(this.modalId);
    },
    /**
     * @override
     */
    showEditModal(type, entity) {
      this.type = type;
      this.form = { ...entity };
      this.$bvModal.show(this.editModalId);
    },
    /**
     * @override
     */
    submitEditEntity() {
      const method = this.type === 'distributor' ? this.$distributorsService : this.$subdistributorsService;
      const uuid_update = this.type !== 'distributor' ? this.form.uuid : this.form.uuid_distributor;
      method
        .update(uuid_update, this.form)
        .then(res => {
          this.$toast.success(res.result.http_code, res.result.info);
        })
        .catch(err => {
          this.$toast.error(err.name, err.message);
        })
        .finally(() => {
          this.hideModal();
        });
    },
    /**
     * @override
     */
    hideModal(noRefresh) {
      this.$bvModal.hide(this.modalId);
      this.$bvModal.hide(this.deleteModalId);
      this.$bvModal.hide(this.editModalId);
      this.distributorSelected = {};
      this.form = {};
      this.deleteEntity = {};
      this.type = 'distributor';
      if (!noRefresh) {
        this.fetchData();
      }
    },
    /**
     * @param {String} type distributor or subdistributor
     * @param {Object} data user row data
     */
    distributorClick(type, data) {
      const item = {
        active: true,
        name: data.key_name,
        route: {
          name: `distributors_uuid`,
          params: {
            uuid: type === 'distributor' ? data.uuid_distributor : data.uuid,
            type
          },
          force: true
        }
      };
      this.setMenuTab(item);
    },
    /**
     * @override
     */
    submitEntity() {
      if (this.distributorSelected) {
        this.form.uuid_distributor = this.distributorSelected.uuid_distributor;
      }
      this.form.refer_code = '12345';
      const method = this.type === 'distributor' ? this.$distributorsService : this.$subdistributorsService;
      method
        .create(this.form)
        .then(res => {
          this.$toast.success(res.result.http_code, res.result.info);
        })
        .catch(err => {
          this.$toast.error(err.name, err.message);
        })
        .finally(() => {
          this.hideModal();
        });
    },
    /**
     * @override
     */
    showDeleteModal(type, entity) {
      this.type = type;
      this.deleteEntity = entity;
      this.$bvModal.show(this.deleteModalId);
    },
    /**
     * @override
     * @param {Boolean} confirm confirm to delete entity
     * @param {String} type type of entity 'distributor' or 'subdistributor'
     * @param {Object} entity entity
     */
    confirmDelete(confirm) {
      if (confirm === true) {
        this.deleteDistributor();
      } else {
        this.hideModal(true);
      }
    },
    /**
     * @override
     */
    deleteDistributor() {
      const method =
        this.type === 'distributor'
          ? this.$distributorsService.deleteDistributorByUUId
          : this.$subdistributorsService.deleteSubdistributorByUUId;
      method(this.type !== 'distributor' ? this.deleteEntity.uuid : this.deleteEntity.uuid_distributor)
        .then(res => {
          this.$toast.success(res.result.http_code, res.result.info);
        })
        .catch(err => {
          this.$toast.error(err.name, err.message);
        })
        .finally(() => {
          this.hideModal();
        });
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.distributors = {
      fields: [
        {
          key: 'expand',
          label: '',
          class: 'c-col c-expand'
        },
        {
          key: `key_name`,
          label: `Distribuidor`,
          class: 'distributor_name c-col'
        },
        {
          key: 'total_users',
          label: 'Nº Usuarios',
          class: 'c-col'
        },
        {
          key: 'accounts.quantity',
          label: 'Nº Cuentas',
          class: 'c-col'
        },
        {
          key: 'accounts.total_net_assets_value',
          label: 'Patrimonio total',
          class: 'c-col'
        },
        {
          key: 'actions',
          label: '',
          class: 'c-col'
        }
      ],
      items: []
    };

    this.fetchData();
  }
};
